import Content from "../templates/wrapper/Content";
import SendAgainFlow from "../molecules/sendAgain/SendAgainFlow";
import Text from "../molecules/content/Text";
import ActionLinkButton from "../atoms/buttons/ActionLinkButton";
import { useNavigate } from "react-router-dom";
import OneTimePasswordForm from "../organisms/forms/oneTimePassword/OneTimePasswordForm";
import { useTranslation } from "react-i18next";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../context/authContext";
import { useToast } from "../../hooks/useToast";
import { ErrorDefinition } from "../../helpers/const";
import SignOutButton from "../molecules/buttons/SignOutButton";
import { useDialog } from "../../hooks/useDialog";

const AccountVerificaiton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { showDialog } = useDialog();
  const authContext = useContext(AuthContext);

  const handleClickConfirmPhoneCode = async (values) => {
    try {
      await authContext.verifyAttribute(values.otp, "phone_number");
      const username = authContext.sessionInfo.username;
      localStorage.setItem("username", username?.Value);
      await authContext.refreshSession();
      showDialog(
        t("accountVerification.accountCreatedTitle"),
        t("accountVerification.accountCreatedMessage"),
        t("dialog.okey"),
        true,
        "",
        "success",
        () => {
          window.location.href = "/";
        }
      );
    } catch (error) {
      if (error.message === ErrorDefinition.ConfirmAttributeCodeError) {
        showToast(
          "error",
          t("confirmAttribute.confirmAttributeCodeErrorMessage")
        );
      }
    }
  };

  const handleSendPhoneCode = async (isShowToast = false) => {
    try {
      await authContext.getAttributeVerificationCode("phone_number");
      if (isShowToast) {
        showToast("success", t("accountVerification.successMessage"));
      }
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  const signOutClicked = async () => {
    try {
      await authContext.signOut();
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  useEffect(() => {
    handleSendPhoneCode();
  }, []);

  return (
    <Content isConfirmedPage onClose={signOutClicked}>
      <div className="flex flex-col items-center gap-4">
        <Text variant="h3" className="text-vestelColor">
          {t("accountVerification.title")}
        </Text>
        <Text>{t("accountVerification.description")}</Text>
      </div>
      <div className="pt-12 pb-8">
        <OneTimePasswordForm onSubmit={handleClickConfirmPhoneCode} />
      </div>
      <div className="flex flex-col items-center justify-center gap-8">
        <SendAgainFlow
          label={t("accountVerification.resendCode")}
          resendFunction={() => handleSendPhoneCode(true)}
        />
        <ActionLinkButton
          text={t("accountVerification.verifyWithDifferentPhone")}
          handleClick={() => navigate("/verify/phone")}
        />
      </div>
      <div className="text-center py-12">
        <SignOutButton />
      </div>
    </Content>
  );
};

export default AccountVerificaiton;
